module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-2-6544be7f97ed7075120d95da6df300bc.svg";